function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.786 13.839l-3.117-3.117a.75.75 0 00-.531-.219h-.512a6.499 6.499 0 10-1.126 1.125v.512a.748.748 0 00.22.532l3.116 3.117a.748.748 0 001.06 0l.884-.885a.753.753 0 00.006-1.065zm-9.282-3.335a4 4 0 11.004-8 4 4 0 01-.006 8h.002z",
  fill: "#474B51"
});
function SvgFeatureSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgFeatureSearch;